import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { newMacro } from '../actions/NewMacro';
import { DialogMacroEdit } from '../components/DialogMacroEdit';
import { editMacro } from '../actions/EditMacro';
import { allMacros } from '../features/macros/macrosSlice';
export const ConfigMacros = () => {
    const macros = useAppSelector(state => allMacros(state.definitions.macros));
    const dispatch = useAppDispatch();
    const rows = [];
    for (const m of macros) {
        const label_classes = 'inactive label ' + (m.active ? ' hidden' : '');
        rows.push(_jsxs("div", { children: [_jsxs("div", { children: [m.title, _jsx("span", { className: label_classes, children: "Inaktiv" })] }), _jsx("div", { children: _jsx("button", { className: "lw small", onClick: () => dispatch(editMacro(m.id)), children: "Redigera" }) })] }, m.id));
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx(DialogMacroEdit, {}), _jsx("div", { className: "operations", children: _jsx("button", { className: "lw success", onClick: () => dispatch(newMacro()), children: "L\u00E4gg till scen..." }) }), _jsx("div", { className: "config-rows config-macros", children: rows })] }));
};
